import { render, staticRenderFns } from "./PageDataTabs.vue?vue&type=template&id=5f906a0d&scoped=true&"
import script from "./PageDataTabs.vue?vue&type=script&lang=js&"
export * from "./PageDataTabs.vue?vue&type=script&lang=js&"
import style0 from "./PageDataTabs.vue?vue&type=style&index=0&id=5f906a0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f906a0d",
  null
  
)

export default component.exports